import React, { useEffect } from "react";
import { useRouter } from "next/router";
import Link from "next/link";

import AuthorData from "../../../../data/authors.json";
import ShortsData from "../../../../data/shorts.json";
// import ModuleData from "../../../data/terraform-modules.json";
import PageHead from "@/pages/Head";
import { Provider } from "react-redux";
import Store from "@/redux/store";
import Context from "@/context/Context";
import MobileMenu from "@/components/Header/MobileMenu";
import HeaderStyleTen from "@/components/Header/HeaderStyle-Ten";
import Cart from "@/components/Header/Offcanvas/Cart";
import BackToTop from "@/pages/backToTop";
import Separator from "@/components/Common/Separator";
import FooterOne from "@/components/Footer/Footer-One";
// import BlogDetails from "@/components/Blogs/BlogDetails";
import ShortsEpisode from "@/components/Shorts/ShortsEpisode";
import BlogListItems from "@/components/Blogs/Blog-Sections/BlogList-Items";
import Instagram from "@/components/Instagram/Instagram";
// import BlogBreadCrumb from "@/components/Common/Blog-BreadCrumb";
import EpisodeBreadCrumb from "@/components/Shorts/Episode-BreadCrumb";
import { serialize } from 'next-mdx-remote/serialize'
// import { MDXRemote } from 'next-mdx-remote'
import { readFile } from 'fs/promises'

export default function SingleBlog({ mdxSource }) {
  const router = useRouter();
  // const seasonId = router.query.seasonId;
  const episodeId = router.query.episodeId;

  // console.log(moduleId)

  const authors = JSON.parse(JSON.stringify(AuthorData.authorList));
  const Author = authors.find((author) => author.id === "akbar-hussain");
  const shortEpisodes = JSON.parse(JSON.stringify(ShortsData.episodeList));
  const matchedBlog = shortEpisodes.find((blog) => blog.id === episodeId);
  matchedBlog['author'] = [Author]

  const seasonNum = (matchedBlog)?.season || 1;
  let seasonsList = JSON.parse(JSON.stringify(ShortsData.seasonList));
  let seasonData = seasonsList.find((item) => item.season === seasonNum);

  // const episodeId = matchedBlog.episode;
  let nextShorts = [];
  let nextShort;
  if (episodeId < 10) {
    nextShort = blogPosts.find((blog) => blog.episode === (episodeId + 1));
    nextShorts = [nextShort]
  }
  //  else {
  //   nextShort = blogPosts.find((blog) => blog.episode === 1);
  // }

  useEffect(() => {
    if (episodeId && !matchedBlog) {
      router.push("/shorts");
    }
  }, [matchedBlog, router]);

  // console.log(matchedBlog)

  return (
    <>
      <PageHead title={matchedBlog.title} category="Shorts" />
      <Provider store={Store}>
        <Context>
          <MobileMenu />
          <HeaderStyleTen headerSticky="rbt-sticky" headerType="" />
          <Cart />

          <div className="rbt-overlay-page-wrapper">

            <EpisodeBreadCrumb blogType={"short"} matchedBlog={matchedBlog} categoryPath={"/shorts/" + seasonData.id} />


            <div className="rbt-blog-details-area rbt-section-gapBottom breadcrumb-style-max-width">
              <div className="blog-content-wrapper rbt-article-content-wrapper">

                <ShortsEpisode
                  blogType={"short"}
                  matchedBlog={matchedBlog !== undefined ? matchedBlog : ""}
                  blogContent={mdxSource}
                  author={Author}
                />

                <div className="related-post pt--60">
                  <div className="section-title text-start mb--40">
                    <span className="subtitle bg-primary-opacity">
                      Related Shorts
                    </span>
                    <h4 className="title">Next Episode</h4>
                  </div>
                  <BlogListItems
                    blogType={"short"}
                    selectedBlogs={nextShorts}
                    start={0}
                    end={1}
                  />
                </div>
              </div>
            </div>

            <Instagram />
          </div>

          <BackToTop />
          <Separator />
          <FooterOne />
        </Context>
      </Provider>
    </>
  );
};

export async function getStaticProps(context) {
  // const seasonId = context.params.seasonId;
  const episodeId = context.params.episodeId
  const fileName = `./content/shorts/${episodeId}.mdx`
  // MDX text - can be from a local file, database, CMS, fetch, anywhere...
  const mdxText = await readFile(fileName, 'utf8')
  const mdxSource = await serialize(mdxText)
  return { props: { episodeId, mdxSource } }
}

export async function getStaticPaths(context) {
  const shortEpisodes = JSON.parse(JSON.stringify(ShortsData.episodeList));
  const paths = shortEpisodes.map((episode) => ({
    params: { seasonId: "s" + episode.season, episodeId: episode.id }
  }))
  // const paths = [
  //   { params: { seasonId: "s1", episodeId: "what-is-cloud-computing" } },
  //   { params: { seasonId: "s1", episodeId: "who-are-cloud-providers" } },
  //   { params: { seasonId: "s1", episodeId: "different-types-of-cloud-computing" } },
  //   { params: { seasonId: "s1", episodeId: "cloud-service-models-saas-explained" } },
  //   { params: { seasonId: "s1", episodeId: "cloud-service-models-paas-explained" } },
  //   { params: { seasonId: "s1", episodeId: "cloud-service-models-iaas-explained" } },
  //   { params: { seasonId: "s1", episodeId: "saas-paas-iaas-explained-with-example" } },
  //   { params: { seasonId: "s1", episodeId: "cloud-security-explained" } },
  //   { params: { seasonId: "s1", episodeId: "cloud-computing-pricing-model" } },
  //   { params: { seasonId: "s1", episodeId: "career-opportunities-in-cloud-computing" } }
  // ]
  return { paths, fallback: false }
}